import React, { useMemo } from "react";
import { AuthContext } from "./context";
import { useReducerAsync } from "use-reducer-async";
import { signIn, signOut, refresh } from "./api";
import Cookies from "js-cookie";
const rootReducer = (state, action) => {
    switch (action.type) {
        case "SIGN_IN_START": {
            return Object.assign(Object.assign({}, state), { isLoading: true });
        }
        case "SIGN_IN_SUCCESS": {
            return Object.assign(Object.assign({}, state), { errors: [], accessToken: action.payload.accessToken, refreshToken: action.payload.refreshToken, isAuth: true, isLoading: false });
        }
        case "SIGN_IN_FAILURE": {
            return Object.assign(Object.assign({}, state), { isAuth: false, isLoading: false, errors: action.payload.errors });
        }
        case "SIGN_OUT_START": {
            return Object.assign(Object.assign({}, state), { isLoading: true });
        }
        case "SIGN_OUT_SUCCESS": {
            return Object.assign(Object.assign({}, state), { errors: [], accessToken: "", refreshToken: "", isAuth: false, isLoading: false });
        }
        case "SIGN_OUT_FAILURE": {
            return Object.assign(Object.assign({}, state), { isLoading: false, errors: action.payload.errors });
        }
        // case
        case "REFRESH_TOKEN_START": {
            return Object.assign(Object.assign({}, state), { isLoading: true });
        }
        case "REFRESH_TOKEN_SUCCESS": {
            return Object.assign(Object.assign({}, state), { errors: [], accessToken: "", refreshToken: "", isAuth: false, isLoading: false });
        }
        case "REFRESH_TOKEN_FAILURE": {
            return Object.assign(Object.assign({}, state), { errors: action.payload.errors, isLoading: false });
        }
        case "CHECKOUT_AUTH_START": {
            return Object.assign({}, state);
        }
        case "CHECKOUT_AUTH_SUCCESS": {
            return Object.assign(Object.assign({}, state), { isAuth: true });
        }
        case "CHECKOUT_AUTH_FAILURE": {
            return Object.assign(Object.assign({}, state), { isAuth: false });
        }
        default:
            throw new Error("unknown action type");
    }
};
const createAPIUrl = (baseUrl, endpoint) => `${baseUrl}/${endpoint.replace("/", "")}`;
const asyncActionHandlers = {
    SIGN_IN: ({ dispatch, getState }) => async (action) => {
        var _a;
        dispatch({ type: "SIGN_IN_START" });
        const { baseUrl, endpoints } = getState();
        try {
            const response = await signIn(createAPIUrl(baseUrl, endpoints["signIn"]), action.payload.loginField, action.payload.passwordField);
            if ("errors" in response) {
                throw response;
            }
            dispatch({ type: "SIGN_IN_SUCCESS", payload: response.result });
            Cookies.set("accessToken", response.result.accessToken);
            Cookies.set("refreshToken", response.result.refreshToken);
            //TODO httpOnly & secure cookies
        }
        catch (errorEntity) {
            dispatch({
                type: "SIGN_IN_FAILURE",
                payload: {
                    errors: (_a = errorEntity === null || errorEntity === void 0 ? void 0 : errorEntity.errors) !== null && _a !== void 0 ? _a : errorEntity,
                },
            });
        }
    },
    SIGN_OUT: ({ dispatch, getState }) => async (action) => {
        var _a;
        dispatch({ type: "SIGN_OUT_START" });
        const { baseUrl, endpoints } = getState();
        try {
            const response = await signOut(createAPIUrl(baseUrl, endpoints["signOut"]));
            if ("errors" in response) {
                throw response;
            }
            dispatch({ type: "SIGN_OUT_SUCCESS" });
        }
        catch (errorEntity) {
            dispatch({
                type: "SIGN_OUT_FAILURE",
                payload: {
                    errors: (_a = errorEntity === null || errorEntity === void 0 ? void 0 : errorEntity.errors) !== null && _a !== void 0 ? _a : errorEntity,
                },
            });
        }
    },
    REFRESH_TOKEN: ({ dispatch, getState }) => async (action) => {
        var _a;
        dispatch({ type: "REFRESH_TOKEN_START" });
        const { baseUrl, endpoints, refreshToken } = getState();
        try {
            const response = await refresh(createAPIUrl(baseUrl, endpoints["refresh"]), refreshToken);
            if ("errors" in response) {
                throw response;
            }
            dispatch({ type: "REFRESH_TOKEN_SUCCESS" });
            Cookies.set("accessToken", response.result.refreshToken);
        }
        catch (errorEntity) {
            dispatch({
                type: "REFRESH_TOKEN_FAILURE",
                payload: {
                    errors: (_a = errorEntity === null || errorEntity === void 0 ? void 0 : errorEntity.errors) !== null && _a !== void 0 ? _a : errorEntity,
                },
            });
            if (Cookies.get("accessToken")) {
                Cookies.remove("accessToken");
            }
            if (Cookies.get("refreshToken")) {
                Cookies.remove("refreshToken");
            }
        }
    },
    CHECKOUT_AUTH: ({ dispatch, getState }) => async (action) => {
        dispatch({ type: "CHECKOUT_AUTH_START" });
        if (Cookies.get("accessToken")) {
            dispatch({ type: "CHECKOUT_AUTH_SUCCESS" });
        }
        else {
            dispatch({ type: "CHECKOUT_AUTH_FAILURE" });
        }
    },
};
export const AuthProvider = ({ baseUrl, endpoints, children }) => {
    const initialState = useMemo(() => ({
        baseUrl: baseUrl,
        endpoints: endpoints,
        accessToken: "",
        refreshToken: "",
        isAuth: false,
        isLoading: false,
        errors: null,
    }), [baseUrl]);
    const [state, dispatch] = useReducerAsync(rootReducer, initialState, asyncActionHandlers);
    return (React.createElement(AuthContext.Provider, { value: { state, dispatch } }, children));
};
//# sourceMappingURL=provider.js.map